module.exports = __webpack_public_path__ + "assets/img/ko-cd3b2862.png";